import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { ModalDirective } from "ngx-bootstrap/modal";
import { RadialBarService } from "./radialbar-chart.service";
import * as moment from "moment";
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: "app-radialbar-chart",
  templateUrl: "./radialbar.component.html",
  styleUrls: ["./radialbar.component.scss"],
})
export class RadialBarComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private radialBarService: RadialBarService,
    public spinner: NgxSpinnerService,
    private toastr: ToastrService
  ) {}

  @ViewChild("mdOptionsGrap") mdOptionsGrap: ModalDirective;
  newObject: any;
  @Input() listColumn = [];
  @Input() queryId: string;
  @Input() basedOnId: string;
  @Input() queryConfigType: string;
  @Input() selectTypeGraphic;
  @Input() arguments = [];
  @Output() onVewGraphic: EventEmitter<any> = new EventEmitter<any>();
  registerRadialBarForm: FormGroup;
  controls: any;
  submitted = false;
  dataGraphic: any = {};
  objectGraphic: any = {};
  msgSpiner = 'Cargando...';
  positionList = [
    { name: "right", title: "Derecha" },
    { name: "left", title: "Izquierda" },
    { name: "top", title: "Arriba" },
    { name: "bottom", title: "Abajo" },
  ];
  message = {
    message: null,
    class: null,
  };
  estiloList = [
    { name: "Basic Radialbar", title: "Basic Radialbar" },
    { name: "Multiple Radialbar", title: "Multiple Radialba" },
    { name: "Circle", title: "Circle " },
    { name: "Gradient Circle", title: "Gradient Circle" },
    { name: "Stroked Circular Gauge", title: "Stroked Circular Gaug" },
    { name: "Semi Circular Gauge", title: "Semi Circular Gaug" },
  ];

  //Variable temporal
  objectFinal = {
    series: [76, 67, 61, 90],
    chart: {
      background: "",
      height: 700,
      width: 700,
      type: "radialBar",
      fontSize: "14px",
      toolbar: {
        show: true,
        offsetX: 0,
        offsetY: 0,
        tools: {
          download: true,
          selection: true,
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: true,
          customIcons: [],
        },
        export: {
          csv: {
            filename: undefined,
            columnDelimiter: ",",
            headerCategory: "category",
            headerValue: "value",
            dateFormatter(timestamp) {
              return new Date(timestamp).toDateString();
            },
          },
          svg: {
            filename: undefined,
          },
          png: {
            filename: undefined,
          },
        },
        autoSelected: "zoom",
      },
    },
    title: {
      text: "Radar Chart - Multi Series",
    },
    labels: ["Vimeo", "Messenger", "Facebook", "LinkedIn"],
    legend: {
      show: true,
      floating: false,
      fontSize: "12px",
      position: "left",
      offsetX: 40,
      offsetY: 10,
      labels: {
        useSeriesColors: true,
      },
      itemMargin: {
        horizontal: 3,
      },
    },
  };

  ngOnInit() {
    this.registerRadialBarForm = this.formBuilder.group({
      column: [null, [Validators.required]],
      value: [null, [Validators.required]],
      position: [{ name: "bottom", title: "Abajo" }, [Validators.required]],
      color: ["transparent", [Validators.required]],
      title: ["Titlo de ejemplo", [Validators.required]],
      estilo: [
        { name: "Basic Radialbar", title: "Basic Radialbar" },
        [Validators.required],
      ],
    });
    this.controls = this.registerRadialBarForm.controls;
  }

  showGraphic() {
    this.spinner.show()
    this.submitted = true;

    if (this.registerRadialBarForm.invalid) {
      this.message = {
        message: "Todos los campos son obligatorios",
        class: "alert alert-danger mt-2",
      };
      setTimeout(() => {
        this.message = {
          message: null,
          class: null,
        };
      }, 3000);
      return;
    }

    switch (this.controls.estilo.value.name) {
      case "Basic Radialbar":
        this.newObject = {
          ...this.objectFinal,
          plotOptions: {
            radialBar: {
              hollow: {
                size: "70%",
              },
            },
          },
          labels: ["Cricket"],
        };
        console.log(this.controls.estilo.value.name, "entro");
        break;
      case "Multiple Radialbar":
        this.newObject = {
          ...this.objectFinal,
          plotOptions: {
            radialBar: {
              dataLabels: {
                name: {
                  fontSize: "16px",
                },
                value: {
                  fontSize: "14px",
                },
                total: {
                  show: true,
                  label: "Total",
                  formatter: function (w) {
                    let arr = w.config.series;
                    const reducer = (accumulator, curr) => accumulator + curr;
                    let sum = arr.reduce(reducer);
                    return sum;
                  },
                },
              },
            },
          },
          labels: ["Apples", "Oranges", "Bananas", "Berries"],
        };
        console.log(this.controls.estilo.value.name, "entro");
        break;
      case "Circle":
        this.newObject = {
          ...this.objectFinal,
          plotOptions: {
            radialBar: {
              offsetY: 0,
              startAngle: 0,
              endAngle: 270,
              hollow: {
                margin: 5,
                size: "30%",
                background: "transparent",
                image: undefined,
              },
              dataLabels: {
                name: {
                  show: false,
                },
                value: {
                  show: false,
                },
              },
            },
          },
          colors: ["#1ab7ea", "#0084ff", "#39539E", "#0077B5"],
          labels: ["Vimeo", "Messenger", "Facebook", "LinkedIn"],
          legend: {
            show: true,
            floating: false,
            fontSize: "12px",
            position: "left",
            offsetX: 0,
            offsetY: 10,
            labels: {
              useSeriesColors: true,
            },
            formatter: function (seriesName, opts) {
              return (
                seriesName + ":  " + opts.w.globals.series[opts.seriesIndex]
              );
            },
            itemMargin: {
              horizontal: 3,
            },
          },

          responsive: [
            {
              breakpoint: 480,
              options: {
                legend: {
                  show: false,
                },
              },
            },
          ],
        };
        console.log(this.controls.estilo.value.name, "entro");
        break;
      case "Gradient Circle":
        this.newObject = {
          ...this.objectFinal,
          plotOptions: {
            radialBar: {
              startAngle: -135,
              endAngle: 225,
              hollow: {
                margin: 0,
                size: "70%",
                background: "#fff",
                image: undefined,
                imageOffsetX: 0,
                imageOffsetY: 0,
                position: "front",
                dropShadow: {
                  enabled: true,
                  top: 3,
                  left: 0,
                  blur: 4,
                  opacity: 0.24,
                },
              },
              track: {
                background: "#fff",
                strokeWidth: "67%",
                margin: 0, // margin is in pixels
                dropShadow: {
                  enabled: true,
                  top: -3,
                  left: 0,
                  blur: 4,
                  opacity: 0.35,
                },
              },
              dataLabels: {
                show: true,
                name: {
                  offsetY: -10,
                  show: true,
                  color: "#888",
                  fontSize: "17px",
                },
                value: {
                  formatter: function (val) {
                    return parseInt(val);
                  },
                  color: "#111",
                  fontSize: "36px",
                  show: true,
                },
              },
            },
          },
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              type: "horizontal",
              shadeIntensity: 0.5,
              gradientToColors: ["#ABE5A1"],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100],
            },
          },
          stroke: {
            lineCap: "round",
          },
          labels: ["Percent"],
        };
        console.log(this.controls.estilo.value.name, "entro");
        break;
      case "Stroked Circular Gauge":
        this.newObject = {
          ...this.objectFinal,
          plotOptions: {
            radialBar: {
              startAngle: -135,
              endAngle: 135,
              dataLabels: {
                name: {
                  fontSize: "16px",
                  color: undefined,
                  offsetY: 120,
                },
                value: {
                  offsetY: 76,
                  fontSize: "22px",
                  color: undefined,
                  formatter: function (val) {
                    return val + "%";
                  },
                },
              },
            },
          },
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              shadeIntensity: 0.15,
              inverseColors: false,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 50, 65, 91],
            },
          },
          stroke: {
            dashArray: 4,
          },
          labels: [, "entro"],
        };
        console.log(this.controls.estilo.value.name, "entro");
        break;
      case "Semi Circular Gauge":
        this.newObject = {
          ...this.objectFinal,
          plotOptions: {
            radialBar: {
              startAngle: -90,
              endAngle: 90,
              track: {
                background: "#e7e7e7",
                strokeWidth: "97%",
                margin: 5, // margin is in pixels
                dropShadow: {
                  enabled: true,
                  top: 2,
                  left: 0,
                  opacity: 0.31,
                  blur: 2,
                },
              },
              dataLabels: {
                name: {
                  show: false,
                },
                value: {
                  offsetY: -2,
                  fontSize: "22px",
                },
              },
            },
          },
          fill: {
            type: "gradient",
            gradient: {
              shade: "light",
              shadeIntensity: 0.4,
              inverseColors: false,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 50, 53, 91],
            },
          },
          labels: ["Average Results"],
        };
        console.log(this.controls.estilo.value.name, "entro");
        break;
      default:
        break;
    }

    this.newObject.legend.position =
      this.registerRadialBarForm.controls.position.value.name;
    this.newObject.chart.background =
      this.registerRadialBarForm.controls.color.value;
    this.newObject.title.text = this.registerRadialBarForm.controls.title.value;
    this.newObject.chart.toolbar.export.png.filename =
      this.newObject.title.text +
      "-" +
      moment().format("MMMM Do YYYY, h:mm:ss a");
    this.newObject.chart.toolbar.export.svg.filename =
      this.newObject.title.text +
      "-" +
      moment().format("MMMM Do YYYY, h:mm:ss a");
    this.newObject.chart.toolbar.export.csv.filename =
      this.newObject.title.text +
      "-" +
      moment().format("MMMM Do YYYY, h:mm:ss a");

    this.radialBarService
      .onGetDataGraphic(
        this.queryId,
        this.basedOnId,
        this.arguments,
        this.queryConfigType
      )
      .subscribe((res: any) => {
        this.objectGraphic = this.getDataGrafic(res);
        this.newObject.series = this.objectGraphic.series;
        this.newObject.labels = this.objectGraphic.labels;
        //Se emitirá al componente contenedor el objeto grafico, para posteriormente visializarlo
        this.onVewGraphic.emit(this.newObject);
      }, err => {
        this.toastr.error('Error consulta de datos del grafico Area: ' +  err);
        this.spinner.hide();
        console.log('Error consulta de dtos del grafico Area: ', err);
      });
      this.spinner.hide();
  }

  getDataGrafic(restultGrid) {
    let ListDataGrid = restultGrid.data;
    let object: any = {};
    object.labels = [];
    object.series = [];

    ListDataGrid.forEach((dataGrid) => {
      object.labels.push(
        dataGrid[this.registerRadialBarForm.controls.column.value.field]
      );
      object.series.push(
        dataGrid[this.registerRadialBarForm.controls.value.value.field]
      );
    });
    return object;
  }
}
